/**
 * Generate a page url based on configured base (server),
 *
 * @param pagePath
 * @returns {string}
 */
import {BUOY_SITE_URL} from "./constants"

export const generatePageUrl = (pagePath, isAbsolute = false) => {
  let fullUrl = BUOY_SITE_URL

  if (pagePath) {
    // In case an absolute path was given
    if (pagePath.indexOf("http") > -1 || isAbsolute) {
      return pagePath
    }

    // In case someone added the wrong slash
    pagePath = pagePath.replace(/\/+/g, "")
    fullUrl += `/${pagePath}`

    if (pagePath[0] !== "#") {
      // Add trailing slash if not anchor link
      fullUrl += "/"
    }
  }
  return fullUrl
}

/**
 * Generate an imgix url for the static directory
 *
 * @param imgPath
 * @returns {string}
 */
export const getImageUrl = url => {
  if (url.endsWith("svg") || url.endsWith("gif")) {
    return url
  }

  // If we actually start using local images, this should read
  // process.env.ENVIRONMENT and only use imgix when appropriate.
  let final_url = "https://buoyhealth.imgix.net/"

  // Remove initial 'images/' from url as this is included in the imgix source.
  if (url.indexOf('/') > -1){
    final_url += url.split('/').slice(1).join('/')
  }
  else
    final_url += url

  return final_url
}



// WEBPACK FOOTER //
// ./src/common/utils.js